// Métadonnées des guides pratiques (titre, description, date). Le contenu détaillé
// est dans practical_guides.js, chargé uniquement sur les pages de guide.
export const GUIDES = [
  {
    slug: "assurance-decennale-refusee-bct",
    audience: "artisan",
    title: "Assurance décennale refusée : saisir le BCT (délais 2026)",
    desc: "Refus d’assurance décennale ? Le BCT peut obliger un assureur à vous couvrir. Conditions, délais de 15 et 45 jours, dossier et nouveautés de la loi de 2026.",
    h1: "Assurance décennale refusée : comment saisir le Bureau central de tarification ?",
    updated: "2026-09-29",
  },
  {
    slug: "mention-decennale-devis-factures",
    audience: "artisan",
    title: "Décennale sur devis et factures : obligations et modèle",
    desc: "Attestation jointe, mentions du Code de l’artisanat, couverture géographique : ce que la loi impose sur vos devis et factures, avec un générateur gratuit.",
    h1: "Assurance décennale sur les devis et factures : ce qui est obligatoire",
    updated: "2026-09-29",
  },
  {
    slug: "travailler-sans-assurance-decennale",
    audience: "artisan",
    title: "Travailler sans assurance décennale : risques et sanctions",
    desc: "Sans décennale : jusqu’à 75 000 € d’amende et 6 mois de prison, réparations à vos frais pendant 10 ans, gérant exposé. Ce que dit la loi et comment régulariser.",
    h1: "Travailler sans assurance décennale : quels risques pour un artisan ?",
    updated: "2026-09-29",
  },
  {
    slug: "decennale-creation-entreprise",
    audience: "artisan",
    title: "Décennale en création d’entreprise : préparer son dossier",
    desc: "Vous créez une entreprise du bâtiment ? Préparez votre demande de décennale : expérience, activités, justificatifs et vérifications avant le premier chantier.",
    h1: "Quelle assurance décennale en création d’entreprise ?",
    updated: "2026-09-24",
  },
  {
    slug: "decennale-sous-traitant",
    audience: "artisan",
    title: "Décennale du sous-traitant : obligations et garanties",
    desc: "Vous intervenez comme sous-traitant du bâtiment ? Distinguez obligation décennale, responsabilité contractuelle et garanties à vérifier avant vos travaux.",
    h1: "Un sous-traitant doit-il avoir une assurance décennale ?",
    updated: "2026-09-24",
  },
  {
    slug: "resilier-changer-assurance-decennale",
    audience: "artisan",
    title: "Résilier ou changer d’assurance décennale : délais, règles",
    desc: "Changer d’assurance décennale sans trou de garantie : préavis de 2 mois, modes de notification, résiliation par l’assureur et cas de cessation d’activité.",
    h1: "Résilier ou changer d’assurance décennale sans rupture de garantie",
    updated: "2026-09-29",
  },
  {
    slug: "decennale-cessation-activite",
    audience: "artisan",
    title: "Décennale après cessation d’activité, retraite, liquidation",
    desc: "Retraite, fermeture, liquidation : vos chantiers passés restent couverts 10 ans par l’assureur de l’époque. Résiliation, documents à garder, droits des clients.",
    h1: "Cessation d’activité : que devient votre assurance décennale ?",
    updated: "2026-09-29",
  },
  {
    slug: "parfait-achevement-biennale-decennale",
    audience: "tous",
    title: "Parfait achèvement, biennale, décennale : les différences",
    desc: "Parfait achèvement (1 an), biennale (2 ans), décennale (10 ans) : ce que couvre chaque garantie, qui paie et comment la faire jouer après la réception.",
    h1: "Parfait achèvement, biennale, décennale : quelles différences ?",
    updated: "2026-09-29",
  },
  {
    slug: "verifier-attestation-decennale",
    audience: "client",
    title: "Vérifier une attestation décennale : les points à contrôler",
    desc: "Avant un chantier, vérifiez l’attestation décennale : entreprise, assureur, activités, date d’ouverture et authenticité. Une checklist pour clients et artisans.",
    h1: "Comment vérifier une attestation d’assurance décennale ?",
    updated: "2026-09-24",
  },
];

export const guideBySlug = (slug) => GUIDES.find((guide) => guide.slug === slug);

export const guidePath = (slug) => `/guide/${slug}`;
